import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AppAuthGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  /**
   * Restricts admin route to administrators, redirects to root
   * @param next the route snapshot
   * @param state the router state
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userService.getUserProfile().pipe(
      map(user => {
        if (! ((user) ? user.roleNameBag[0] === 'ROLE_ADMINISTRATOR' : false)) {
          this.router.navigate(['/']);
          return false;
        }
        return true;
      }),
      catchError((err) => {
        return of(false);
      })
    );
  }
}
